import React from "react";
import { Col, Form } from "react-bootstrap";

function AuthenticatingUserShimmer(){

    return(
        <div className='sprint17-verification-pg sprint16bg pt-4 '>

        <div className='sprint17-lg-col'>
          <div className='sprint17-verification-heding'>
            <h6>
                <div className="shimmer-h20 w-100 shimmerBG" ></div>
            </h6>
            <p> 
                <div className="shimmer-h40 w-100 shimmerBG" ></div>
            </p>
          </div>

          {/* radio button */}
          <div className="sprint17-verifi-sec01">
            {[1,2,3].map(item => (
              <div className="w-100">
                <label for="radio-1" class="radio-custom-label d-flex ">
                <div className="shimmer-h20 w-100 shimmerBG" >
                </div>
                </label>
              </div>
            ))}
          </div>
        </div>


        <div className='sprint17-verification-conent sprint17_white_bg'>
       <div className="sprint17-verifi-sec02">
        <div>
              <div className='sprint17-form-row'>
                <div className='sprint17-ver001'>
                  <h5  className="d-flex justify-content-around"><div className="w-80 shimmerBG justify-content-around shimmer-h25 w-75" ></div></h5>
                  <p className="justify-content-around ">
                    <div className="w-100 shimmerBG justify-content-around shimmer-h40" ></div>
                    {/* <div className="w-100 shimmerBG justify-content-around" ></div> */}
                  </p>
                </div>
                <div className='sprint17-mnumber'>
                  <h5 className="d-flex justify-content-around"> <div className="w-60 shimmerBG justify-content-around shimmer-h25 w-50" ></div></h5>
                </div>
              </div> 

              <div className={`sprint17-text-field mt-2`}>
                <Form.Group as={Col} md="12" controlId="validationCustom02" className='sprint16-form-control'>
                  {/* <Form.Label>Enter Code</Form.Label> */}
                  <div className="w-40 shimmer-h40 shimmerBG" ></div>
                </Form.Group>
                <div className='sprint17-resendotp'>
                  <div className='resend-btn w-50 text-left'>
                    
                       <div className="w-40 shimmerBG" ></div>
                  </div>
                  <div className="w-20 shimmerBG" ></div>
                  {/* <div className='resend-timer'>0.40 S</div> */}
                </div>
              </div>
              </div>

              <div className='sprint17-tandc'>
                <p className="d-flex justify-content-around">
                    <div className="w-60 shimmerBG" ></div>
                </p>
                <div>
                  <a className="d-flex justify-content-around"><div className="w-60 shimmerBG" ></div></a>
                </div>
              </div>
              <section class="fixed_footer">
                <div class="fixed_footer_container">
                  <button 
                    class={`custom_btn custom_btn_primary btn_block `} 
                    disabled={true }  >
                  </button>
                  </div>
              </section>
            </div>

      {/* <TermsAndConditions show={show} toggleModal={handleToggle} handleCheck={handleCheck}/> */}
    </div>
  
      </div>
    )
}
export default AuthenticatingUserShimmer